import type { UserAbridged } from "@/types/AbridgedResponse";
import { apiService } from "./base-api-service/base-api-service";
import { endPoints, getDashboardOrchestrationServiceEndPoint } from "./base-url/api-constants";
import { getAuthHeader, readCookie, normalizeGuid } from "@/utils/helper";
import UserService from "./UserService";
import { getServiceToken } from "@/utils/general-config";
import { DocumentUpdateActionEnum } from "./enum/document-update-action-enum";

class DashboardOrchestrationService {
  DashboardOrchestrationService(url: string) {
    return getDashboardOrchestrationServiceEndPoint(url);
  }

  async generateSasUriTokenForContainer(hoursExpiry: number): Promise<string> {
    try {

      let token = readCookie("jwtToken");
      const jwtToken = token ? token : getServiceToken();
      // const jwtToken = readCookie("jwtToken");
      const headers = { Authorization: "Bearer" + " " + jwtToken };
      const sasTokenEndPoint = endPoints.dashboardOrchestrationService.SAS_TOKEN;
      const serviceEndpoint = this.DashboardOrchestrationService(
        sasTokenEndPoint.replace(":expiryHours", hoursExpiry.toString())
      );
      
      const response = await apiService.get(serviceEndpoint, null, headers);
      return response as string;
    } catch (error) {
      console.error("Error generating SAS token:", error);
      throw error;
    }
  }
  OperationLimit(data: any): Promise<number> {
    const apiEndpoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.OPERATION_LIMIT}`
    );
    return apiService.post(apiEndpoint, data, getAuthHeader());
  }

 async updateDocumentAction(data: any): Promise<any> {
    try {
      const jwtToken = readCookie("jwtToken");
      const headers = { Authorization: "Bearer" + " " + jwtToken };

      const updateDocumentEndPoint = this.DashboardOrchestrationService(
        endPoints.dashboardOrchestrationService.UPDATE_DOCUMENT_ACTION,
      );

      return await apiService.put(updateDocumentEndPoint, data, headers);
    } catch (error) {
      console.error("Error updating document action:", error);
      throw error;
    }
  }

async updateDocumentDownloadDate(docId: string, fileType: string = "pdf", itemType: string = "FILE"): Promise<any> {
    const userGuid =   normalizeGuid(readCookie("userguid"));
    const requestBody = {
      userGuid,
      action: DocumentUpdateActionEnum.setdownloaddate,
      docUpdates: [
        {
          docId,
          fileType,
          itemType
        },
      ],
    };
    return this.updateDocumentAction(requestBody);
  }
  async convertDoc(data: any): Promise<any> {
    try {
      const jwtToken = readCookie("jwtToken");
      const headers = { Authorization: "Bearer" + " " + jwtToken };

      const convertDocumentEndPoint = this.DashboardOrchestrationService(
        endPoints.dashboardOrchestrationService.CONVERT_DOC,
      );

      return await apiService.post(convertDocumentEndPoint, data, headers);
    } catch (error) {
      console.error("Error converting document:", error);
      throw error;
    }
  }
}
export const getUserAbridged = async (): Promise<UserAbridged> => {
  return await UserService.getUserObject();
};

export default new DashboardOrchestrationService();
